import { useQuery } from "@tanstack/react-query";
import { ProjectResponse } from "../../../types/project";
import { ApiError } from "../../../types/apiError";
import { getProjectsSummary } from "../api/getProjectsSummary";

export const useProjectsSummaryQuery = (appUserUuid?: string) =>
  useQuery<ProjectResponse, ApiError>({
    queryKey: ["projects-summary", appUserUuid],
    queryFn: () => {
      return getProjectsSummary(appUserUuid);
    },
    placeholderData: (previousData) => previousData,
  });
